import { useMutation } from '@tanstack/react-query'

import { updateReservation } from '../api/updateReservation'
import { UpdateReservationParams } from '../types'

type UseUpdateReservationParams = {
	reservation: UpdateReservationParams
	hotelCode: string
}

export const useUpdateReservation = (onSuccess: () => void) =>
	useMutation({
		mutationFn: ({ reservation, hotelCode }: UseUpdateReservationParams) =>
			updateReservation(reservation, hotelCode),
		onSuccess,
	})
